import { AuthRepositoryAdapter } from '.'
import { FetchAdapter } from '.'
import { EmailResponse } from './domain/models/EmailResponse'
import { EmailVerification } from './domain/models/EmailVerification'
import { Login } from './domain/models/Login'
import { PasswordUpdate } from './domain/models/PasswordUpdate'
import { Session } from './domain/models/Session'
import { Signup } from './domain/models/Signup'
import {
  VerificationCode,
  VerificationCodeTest
} from './domain/models/VerificationCode'
import {
  VerificationLoginCode,
  VerificationLoginCodeTest
} from './domain/models/VerificationLoginCode'
import { AuthRepository } from './domain/repositories/AuthRepository'

export * from '@auth/external/fetchAdapter'
export * from '@auth/infra/datasource/authRepositoryAdapter'

export const authInstance = Auth(AuthRepositoryAdapter(FetchAdapter))

export function Auth(repository: AuthRepository) {
  return {
    async login(login: Login) {
      return await repository.login(login)
    },

    async logout() {
      return await repository.logout()
    },

    async signup(signup: Signup) {
      return await repository.signup(signup)
    },

    async refresh(token: string): Promise<Session> {
      return await repository.refresh(token)
    },

    async sendEmailCode(
      emailToRecovery: EmailVerification
    ): Promise<EmailResponse> {
      return await repository.sendEmailCode(emailToRecovery)
    },
    async sendEmailLoginCode(
      emailToRecovery: EmailVerification
    ): Promise<EmailResponse> {
      return await repository.sendEmailLoginCode(emailToRecovery)
    },

    async testVerificationCode(
      verificationCode: VerificationCode
    ): Promise<VerificationCodeTest> {
      return await repository.testVerificationCode(verificationCode)
    },
    async testVerificationLogin(
      verificationUserName: VerificationLoginCode
    ): Promise<VerificationLoginCodeTest> {
      return await repository.testVerificationLogin(verificationUserName)
    },

    async changePassword(
      passwordUpdate: PasswordUpdate
    ): Promise<VerificationCodeTest | void> {
      return await repository.changePassword(passwordUpdate)
    }
  }
}
